import { useSelector } from 'react-redux';
import { RootState } from 'store';

function useCurrentSelectedSite() {
  const masterSlave = useSelector((state: RootState) => state.masterSlave);
  const currentSelectedSiteName = masterSlave?.masterSlave?.CurrentyLoggedClient;
  const currentSelectedSiteGuid = masterSlave?.masterSlave?.CurrentSiteGuid;
  const sites = masterSlave?.masterSlave?.SlaveDetails;

  let site;
  if (sites?.length && currentSelectedSiteGuid) {
    site = sites.find((s: any) => s.DbTenantId === currentSelectedSiteGuid);
  } else if (sites?.length && currentSelectedSiteName) {
    site = sites.find((s: any) => s.Name === currentSelectedSiteName);
  }

  if (!site) {
    return {
      site
    };
  }

  return {
    site: {
      ...site,
      DbTenantId: process.env.REACT_APP_TENANT_ID || site.DbTenantId
    }
  };
}

export default useCurrentSelectedSite;
